import React, { Component } from 'react'

import { Avatar } from 'component-library-next'
import moment from 'moment'

import ControledInput from '@app/common/Components/Inputs/ControlledInput'
import { Gender } from '@app/graphql/types'
import { getSalutation } from '@app/modules/Messages/utils/gender'

import './style.scss'

const FORMAT_DATE_DAY_FIRST = 'DD.MM.YYYY'

type Props = {
  customer: {
    id?: number
    profilePictureUrl?: string
    firstName?: string
    lastName?: string
    productName?: string
    gender?: Gender
    phone?: string
    email: string
    membershipNumber?: string
    dateOfBirth?: Date
    note?: string
  }
}

export default class ClientInfo extends Component<Props> {
  render() {
    const {
      firstName: firstNameRaw,
      lastName: lastNameRaw,
      profilePictureUrl,
      gender,
      phone,
      email,
      membershipNumber,
      dateOfBirth,
      productName
    } = this.props.customer

    const genderVal = gender ? getSalutation(gender) : ''
    const lastName = lastNameRaw ? `${lastNameRaw}` : ''
    const firstName = firstNameRaw ? `, ${firstNameRaw}` : ''

    const fullName = `${lastName}${firstName}`
    const avatarTitle = productName ? `${productName}-Mitglied` : null

    // TODO: Add this information in the graphQL model to be able to display it
    const zip = null
    const city = null
    const mobile = null

    const address = ''
    const houseNumber = ''

    return (
      <div className='client-block'>
        <form>
          <div className='client-top-block'>
            <div className='client-top__left'>
              <h1 className='heading-1 page-title'>{fullName}</h1>
              <h4 className='subheading-text'>Kontaktdaten</h4>
            </div>

            <div className='client-top__right'>
              <Avatar image={profilePictureUrl || undefined}>{avatarTitle}</Avatar>
            </div>
          </div>

          <div className='client-bottom-block'>
            <div className='input-row has-message'>
              <ControledInput
                name='gender'
                type='text'
                placeholder='Anrede'
                disabled
                value={genderVal || ''}
              />
              <ControledInput
                name='membership_number'
                type='text'
                placeholder='Mitgliedsnummer'
                disabled
                value={membershipNumber || ''}
              >
                <div className='note-message'>Mitgliedsnummer</div>
              </ControledInput>
            </div>

            <div className='input-row'>
              <ControledInput
                name='address'
                type='text'
                placeholder='Straße'
                disabled
                value={address || ''}
              />
              <ControledInput
                name='house_number'
                type='text'
                placeholder='Hausnummer'
                disabled
                value={houseNumber || ''}
              />
            </div>

            <div className='input-row'>
              <ControledInput name='zip' type='text' placeholder='PLZ' disabled value={zip || ''} />
              <ControledInput
                name='city'
                type='text'
                placeholder='Ort'
                disabled
                value={city || ''}
              />
            </div>

            <div className='input-row'>
              <ControledInput
                name='phone'
                type='text'
                placeholder='Telefonnummer'
                value={phone || ''}
                disabled
              />
              <ControledInput
                name='mobile'
                type='text'
                placeholder='Mobil'
                value={mobile || ''}
                disabled
              />
            </div>

            <div className='input-row'>
              <ControledInput
                name='email'
                type='email'
                placeholder='E-mail'
                value={email || ''}
                disabled
              />
              <ControledInput
                name='date'
                type='text'
                placeholder='Geburtsdatum'
                value={dateOfBirth ? moment(dateOfBirth).format(FORMAT_DATE_DAY_FIRST) : ''}
                disabled
              />
            </div>
          </div>
        </form>
      </div>
    )
  }
}
